export default {"src":"/_next/static/image/public/images/ic_file_jpg.9df3999ae380d90db5f66a549024dca7.svg","height":24,"width":24};